// Space activates a reaction pill that is a role=button link (it toggles in place).
// jQuery's event wrapper does not copy `repeat` from the native event, so read it from originalEvent.
// Without this, holding Space re-clicks the pill on every auto-repeat keydown.
// Auto-repeat keydowns still prevent the default, so holding Space does not scroll the page.
export function handleReactionPillSpace(e, control) {
  const native = e.originalEvent || e
  if (e.key !== ' ') return
  e.preventDefault()
  if (native.repeat) return
  control.click()
}
